import {
  burnULXAsync,
  changeAutoStakeAsync,
  claimGamingRewardsAsync,
  confirmNFTWithdrawAsync,
  convertHubToLPAsync,
  getConversionInfoAsync,
  getFlipMeCardsAsync,
  getMyHubsAkashaAsync,
  getMyHubsBigWhaleAsync,
  getMyHubsDexNetAsync,
  getMyHubsGamingAsync,
  getMyHubsGuardianAsync,
  getMyHubsKriptoTapAsync,
  getMyHubsPaymentAsync,
  getMyHubsStakingAsync,
  getMyHubsSummaryAsync,
  getMyHubsTradingAsync,
  getMyHubsTravelAsync,
  getStakingWithdrawalInfoAsync,
  getWiliCoinsSummaryAsync,
  purchaseBigWhaleVoucherAsync
} from './Portfolio.requests';

import { createAsyncThunk } from '@reduxjs/toolkit';
import { Dispatch, SetStateAction } from 'react';
import {
  ErrorToast,
  SuccessToast
} from '../../components/common/Toasts/Toasts';
import { ConversionStepsEnum } from './Conversion/types';
import { RootState } from '../../app/store';
import {
  MY_HUBS_GAMING,
  MY_HUBS_PAYMENT,
  MY_HUBS_STAKING,
  MY_HUBS_TRADING
} from '../../routes/routes';
import { WithdrawStepsEnum } from './WithdrawHubs/types';
import {
  changeAvailableLoyaltyPoints,
  changeAvailableRewardPoints,
  changeAvailableShoppingPoints
} from '../../slices/auth-slice';

export const getMyHubsSummary = createAsyncThunk(
  'getMyHubsSummary',
  async () => {
    const { data } = await getMyHubsSummaryAsync();

    return data;
  }
);

export const getMyHubsTrading = createAsyncThunk(
  'getMyHubsTrading',
  async () => {
    const { data } = await getMyHubsTradingAsync();

    return data;
  }
);

export const getMyHubsAkasha = createAsyncThunk('getMyHubsAkasha', async () => {
  const { data } = await getMyHubsAkashaAsync();
  return data;
});

export const getMyHubsTravel = createAsyncThunk('getMyHubsTravel', async () => {
  const { data } = await getMyHubsTravelAsync();
  return data;
});

export const getMyHubsBigWhale = createAsyncThunk(
  'getMyHubsBigWhale',
  async () => {
    const { data } = await getMyHubsBigWhaleAsync();

    return data;
  }
);

export const getMyHubsPayment = createAsyncThunk(
  'getMyHubsPayment',
  async () => {
    const { data } = await getMyHubsPaymentAsync();

    return data as any;
  }
);

export const getFlipMeCards = createAsyncThunk('getFlipMeCards', async () => {
  const { data } = await getFlipMeCardsAsync();

  return data as any;
});

export const getMyHubsGaming = createAsyncThunk('getMyHubsGaming', async () => {
  const { data } = await getMyHubsGamingAsync();
  return data;
});

export const getMyHubsStaking = createAsyncThunk(
  'getMyHubsStaking',
  async () => {
    const { data } = await getMyHubsStakingAsync();
    return data;
  }
);

export const getMyHubsGuardian = createAsyncThunk(
  'getMyHubsGuardian',
  async () => {
    const { data } = await getMyHubsGuardianAsync();
    return data;
  }
);

export const getMyHubsKriptoTap = createAsyncThunk(
  'getMyHubsKriptoTap',
  async () => {
    const { data } = await getMyHubsKriptoTapAsync();
    return data;
  }
);

export const getMyHubsDexNet = createAsyncThunk('getMyHubsDexNet', async () => {
  const { data } = await getMyHubsDexNetAsync();
  return data;
});

export const getConversionInfo = createAsyncThunk(
  'getConversionInfo',
  async ({
    userPackageId,
    setConversionStep
  }: {
    userPackageId: number;
    setConversionStep: Dispatch<SetStateAction<ConversionStepsEnum>>;
  }) => {
    try {
      const { data } = await getConversionInfoAsync(userPackageId);
      setConversionStep(ConversionStepsEnum.CALCULATOR);
      return data;
    } catch (e: any) {
      ErrorToast(e.response.data.error);
    }
  }
);

export const convertHubToLP = createAsyncThunk(
  'convertHubToLP',
  async (
    {
      userPackageId,
      setConversionStep
    }: {
      userPackageId: number;
      setConversionStep: Dispatch<SetStateAction<ConversionStepsEnum>>;
    },
    { dispatch }
  ) => {
    try {
      const { message } = await convertHubToLPAsync(userPackageId);
      setConversionStep(ConversionStepsEnum.CONFIRM);
      SuccessToast(message);

      switch (window.location.pathname) {
        case MY_HUBS_TRADING: {
          dispatch(getMyHubsTrading());
          break;
        }
        case MY_HUBS_PAYMENT: {
          dispatch(getMyHubsPayment());
          break;
        }
        case MY_HUBS_GAMING: {
          dispatch(getMyHubsGaming());
          break;
        }
        case MY_HUBS_STAKING: {
          dispatch(getMyHubsStaking());
          break;
        }
        default:
          break;
      }
    } catch (e: any) {
      setConversionStep(ConversionStepsEnum.CONFIRM);
      ErrorToast(e.response.data.error);
    }
  }
);

export const getStakingWithdrawalInfo = createAsyncThunk(
  'getStakingWithdrawalInfo',
  async ({
    userPackageId,
    amount
  }: {
    userPackageId: number;
    amount: string;
  }) => {
    const { data } = await getStakingWithdrawalInfoAsync(userPackageId, amount);

    return data?.ulxAmountToBurn;
  }
);

export const burnULX = createAsyncThunk(
  'burnULX',
  async ({
    userPackageId,
    amount,
    setClaim
  }: {
    userPackageId: number;
    amount: string;
    setClaim: Dispatch<SetStateAction<boolean>>;
  }) => {
    await burnULXAsync(userPackageId, amount);

    setClaim(false);

    return userPackageId;
  }
);

export const changeAutoStake = createAsyncThunk(
  'changeAutoStake',
  async ({
    userPackageId,
    newStatus,
    setAutostake,
    toggle,
    setToggle
  }: {
    userPackageId: number;
    newStatus: boolean;
    toggle: boolean;
    setToggle: Dispatch<SetStateAction<boolean>>;
    setAutostake: Dispatch<SetStateAction<boolean>>;
  }) => {
    setAutostake(false);

    const { data, message } = await changeAutoStakeAsync(
      userPackageId,
      newStatus
    );

    SuccessToast(message);
    setToggle(!toggle);

    return data?.userPackage.id;
  }
);

export const claimGamingRewards = createAsyncThunk(
  'claimGamingRewards',
  async () => {
    await claimGamingRewardsAsync();
  }
);

export const confirmNFTWithdraw = createAsyncThunk(
  'confirmNFTWithdraw',
  async ({
    userPackageId,
    walletAddress,
    walletAddressSign,
    emailCode,
    twoFACode,
    setWithdrawStep,
    setLoadingCode
  }: {
    userPackageId: number;
    walletAddress: string | undefined;
    walletAddressSign: string;
    emailCode: string;
    twoFACode: string;
    setWithdrawStep: Dispatch<SetStateAction<WithdrawStepsEnum>>;
    setLoadingCode: any;
  }) => {
    try {
      setLoadingCode(true);
      const { data } = await confirmNFTWithdrawAsync({
        userPackageId,
        walletAddress,
        walletAddressSign,
        emailCode,
        twoFACode
      });

      setWithdrawStep(WithdrawStepsEnum.APPROVE_TRANSACTION_SUCCESS);

      setLoadingCode(false);

      return data;
    } catch (error: any) {
      setLoadingCode(false);
      ErrorToast(error.response.data.error);
    }
  }
);

export const purchaseBigWhaleVoucher = createAsyncThunk(
  'purchaseBigWhaleVoucher',
  async (
    {
      packageId,
      lp,
      club,
      cash,
      usdt,
      usdc,
      networkType,
      handleSuccess
    }: {
      packageId: number;
      networkType: number | null;
      lp: number;
      club: number;
      cash: number;
      usdt: number;
      usdc: number;
      handleSuccess: () => void;
    },
    { dispatch }
  ) => {
    try {
      const { data } = await purchaseBigWhaleVoucherAsync({
        packageId,
        networkType,
        lp,
        club,
        cash,
        usdt,
        usdc
      });

      dispatch(
        changeAvailableRewardPoints(data!.userTickets.availableRewardPoints)
      );
      dispatch(changeAvailableShoppingPoints(data!.userTickets.shoppingPoints));
      dispatch(changeAvailableLoyaltyPoints(data!.userTickets.loyaltyPoints));

      handleSuccess();

      return data;
    } catch (error: any) {
      ErrorToast(error.response.data.error);
    }
  }
);

export const getWiliCoinsSummary = createAsyncThunk(
  'getWiliCoinsSummary',
  async () => {
    const willyCoinsSummary = await getWiliCoinsSummaryAsync();

    return {
      willyCoinsSummary
    };
  }
);

export const updateWillyCoinsSummary = createAsyncThunk(
  'updateWillyCoinsSummary',
  ({
    totalMemeCoins,
    totalCoinsPerChange,
    memeCoinsFromBigWhale,
    finupCoinsPerChange,
    memeCoinsFromBring3,
    fastStartCoinsPerChange
  }: any) => {
    let totalWillyMemeCoins = {
      totalMemeCoins: (totalMemeCoins += totalCoinsPerChange)
    };

    let totalFineUpMemeCoins = {
      memeCoinsFromBigWhale: (memeCoinsFromBigWhale += finupCoinsPerChange)
    };

    let totalFastStartUpMemeCoins = {
      memeCoinsFromBring3: (memeCoinsFromBring3 += fastStartCoinsPerChange)
    };

    return {
      totalWillyMemeCoins,
      totalFineUpMemeCoins,
      totalFastStartUpMemeCoins
    };
  }
);
